import { Link } from "@tanstack/react-router";
import { ShieldOff } from "lucide-react";
import { Button } from "@/components/ui/Button";

export function ForbiddenPage() {
	return (
		<div className="min-h-screen bg-background flex items-center justify-center px-4">
			<div className="text-center max-w-md">
				<div className="mb-6 text-error" aria-hidden="true">
					<ShieldOff size={64} className="mx-auto" />
				</div>
				<h1 className="text-4xl font-bold text-text mb-2">403</h1>
				<h2 className="text-xl font-semibold text-text mb-4">Zugriff verweigert</h2>
				<p className="text-text-secondary mb-8">
					Du hast keine Berechtigung, diese Seite aufzurufen.
				</p>
				<Link to="/">
					<Button variant="primary">Zur Startseite</Button>
				</Link>
			</div>
		</div>
	);
}
